export function calculateLineHeightInPx(lineHeight, fontSize) {
    let result;
    if (!lineHeight) {
        result = parseFloat(fontSize) * 1.14;
    }
    else if (typeof lineHeight === 'number') {
        result = lineHeight * parseFloat(fontSize);
    }
    else if (lineHeight.endsWith('pt')) {
        result = (parseFloat(lineHeight) * 4) / 3;
    }
    else if (lineHeight.endsWith('px')) {
        result = parseFloat(lineHeight);
    }
    else if (lineHeight.endsWith('%')) {
        result = (parseFloat(lineHeight) / 100) * parseFloat(fontSize);
    }
    else if (lineHeight === 'normal') {
        result = parseFloat(fontSize) * 1.2;
    }
    else {
        result = parseFloat(lineHeight) * parseFloat(fontSize);
    }
    return Math.floor(result);
}
//# sourceMappingURL=inject-mobile-line-height-class.js.map